import { Guard, Next } from './Guard'
import { Route } from 'vue-router'
import { TokenInfoService } from '@/services/auth/common/tokenInfo'
// import store from '@/store/index'

export const isAuth: Guard = async (to: Route, from: Route, next: Next) => {
  const loginSessionCheck = TokenInfoService.tokenData()
  // const tokenInfoStore = store.getters['token/TokenInfo']
  // console.log('loginSessionCheck- ', loginSessionCheck)
  if (loginSessionCheck && loginSessionCheck.accessToken) {
    next()
  } else if (!loginSessionCheck) {
    if (to.path !== '/') {
      next('/')
    } else {
      next('login')
    }
  } else {
    next('login')
  }
}
